import { SimpleMarkdownRenderer } from '@components/Markdown/SimpleMarkdownRenderer';
import { styled } from '@mui/material/styles';

export const DraftMarkdown = styled(SimpleMarkdownRenderer)(({ theme }) => ({
  '& p, & li': { fontSize: theme.typography.pxToRem(14), lineHeight: 1.6 },
  '& h1, & h2, & h3, & h4, & h5, & h6': {
    fontWeight: 600,
    color: theme.palette.textColors?.darkText ?? theme.palette.text.primary,
  },
}));
